import { render, staticRenderFns } from "./BreadcrumbAlignment.vue?vue&type=template&id=e405e4ec"
import script from "./BreadcrumbAlignment.vue?vue&type=script&lang=js"
export * from "./BreadcrumbAlignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports